export function tsToDate(ts: string) {
  return new Date(ts);
}

export type ChipColor =
  | "default"
  | "secondary"
  | "error"
  | "success"
  | "primary"
  | "info"
  | "warning";
